import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { SERVICES, serviceHref } from "@/lib/site";
import { Reveal, Eyebrow } from "./Reveal";

const SPAN = ["md:col-span-2 md:row-span-2", "", ""];

const Tile = ({ s, span, i }) => (
  <Reveal delay={i * 0.08} className={`${span} min-h-[320px]`}>
    <Link to={serviceHref(s.key)} data-service={s.key} data-testid={`service-card-${s.key}`} className="group relative flex h-full min-h-[320px] overflow-hidden border border-white/10">
      <img src={s.img} alt={s.alt} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
      <div className="relative mt-auto w-full p-6 md:p-8">
        <div className="flex items-end justify-between gap-4">
          <div>
            <h3 className="font-display text-4xl uppercase leading-none text-white md:text-5xl">{s.title}</h3>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-neutral-300 md:text-base">{s.text}</p>
          </div>
          <span className="flex h-12 w-12 shrink-0 items-center justify-center bg-brand text-white transition-colors group-hover:bg-white group-hover:text-brand">
            <ArrowUpRight className="h-5 w-5" />
          </span>
        </div>
      </div>
    </Link>
  </Reveal>
);

export const Services = () => (
  <section id="egitimler" data-testid="services-section" className="mx-auto max-w-7xl px-5 py-24 md:px-8 md:py-32">
    <Reveal className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
      <div>
        <Eyebrow>Eğitim & Tur</Eyebrow>
        <h2 className="font-display text-5xl uppercase leading-none text-white md:text-7xl">Üç yol, tek kulüp.</h2>
      </div>
      <p className="max-w-sm text-neutral-400">İlk kez deneyecek olan da, yılların sürücüsü de, çocuğu için eğitim arayan aile de burada başlar.</p>
    </Reveal>
    <div className="grid auto-rows-[minmax(320px,auto)] grid-cols-1 gap-3 md:grid-cols-3">
      {SERVICES.map((s, i) => <Tile key={s.key} s={s} span={SPAN[i]} i={i} />)}
    </div>
  </section>
);
